import { render, staticRenderFns } from "./component-info-image.vue?vue&type=template&id=1d524886&scoped=true"
import script from "./component-info-image.vue?vue&type=script&lang=js"
export * from "./component-info-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d524886",
  null
  
)

export default component.exports